import {EVENT_PREFIX} from '../../../helpers';

export default (
  {
    instanceKey,
    stateKey,
    formConfig
  }) => (Object.assign({
  type: `${EVENT_PREFIX}_TOUCH_ALL_FIELDS`
}, {instanceKey, stateKey, formConfig}));
